module.exports = __webpack_public_path__ + "static/media/1040020800.8a7ed0f3.jpg";